/* @ts-expect-error module is untyped */
import { translateFilterValue } from '../../../utils/i18n';
import FormattedHTMLMessage from 'I18n/components/FormattedHTMLMessage';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { Flex } from 'foundations-components/components/Flex';
import { Text } from 'foundations-components/components/Text';
import { Button } from 'foundations-components/transitional/components/Button';
import { Select } from 'foundations-components/transitional/components/Select';
import { Small } from 'foundations-components/transitional/components/Small';
import { WizardStep } from 'foundations-components/transitional/components/Wizard';
import * as Industries from 'marketplace-ui-common/constants/Industry';
import { Fragment, useCallback, useEffect, useMemo, useState } from 'react';
import { INDUSTRY } from '../../../constants/search/FilterKey';
import PillButton from './FindPartnerWizardPillButton';

// TODO: Get full list of industries to show as "Top industries"
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const topIndustries = [Industries.TECHNOLOGY_SOFTWARE, Industries.CONSULTING_ADVISORY, Industries.BANKING_FINANCIAL_SERVICES, Industries.CONSTRUCTION_RENOVATION, Industries.REAL_ESTATE];
export default function FindPartnerWizardIndustryStep({
  filters,
  onFilterChange,
  userInsights
}) {
  const [showMore, setShowMore] = useState(false);
  const [guessed, setGuessed] = useState(null);
  const handleFilterChange = useCallback((value, isGuess) => {
    onFilterChange('industry', value);
    setGuessed(isGuess);
  }, [onFilterChange]);
  useEffect(() => {
    if (!filters.industry.length && userInsights !== null && userInsights !== void 0 && userInsights.portalInsights.industry && guessed === null) {
      handleFilterChange([String(userInsights.portalInsights.industry)], true);
    }
  }, [handleFilterChange, guessed, filters.industry, userInsights]);
  const options = useMemo(() => Object.keys(Industries).map(option => ({
    text: translateFilterValue(INDUSTRY, option),
    value: option
  })), []);
  const renderedTopIndustries = useMemo(() => {
    const filteredIndustries = topIndustries.filter(industry => !filters.industry.includes(industry));
    const expandable = filteredIndustries.length > 5;
    if (filteredIndustries.length < 5) {
      setShowMore(false);
    }
    if (!showMore) {
      filteredIndustries.splice(5);
    }
    return /*#__PURE__*/_jsxs(Fragment, {
      children: [!!filteredIndustries.length && /*#__PURE__*/_jsx(Text, {
        as: "h7",
        marginBlockStart: "700",
        marginBlockEnd: "200",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "ecosystem-marketplace-solutions-ui.homepage.questionnaire.topIndustries"
        })
      }), /*#__PURE__*/_jsx(Flex, {
        flexWrap: "wrap",
        gap: "200",
        children: filteredIndustries.map(industry => /*#__PURE__*/_jsx(PillButton, {
          onClick: () => handleFilterChange([...filters.industry, industry], false),
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: `marketplace-ui-common.industry.${industry}.title`
          })
        }, industry))
      }), !showMore && expandable && /*#__PURE__*/_jsx(Button, {
        onClick: () => setShowMore(true),
        use: "link",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "ecosystem-marketplace-solutions-ui.homepage.questionnaire.seeMore"
        })
      })]
    });
  }, [filters, handleFilterChange, showMore]);
  return /*#__PURE__*/_jsxs(WizardStep, {
    children: [/*#__PURE__*/_jsx(Text, {
      as: "h2",
      "data-test-id": "findPartnerWizard-step-2",
      marginBlockEnd: "1100",
      children: /*#__PURE__*/_jsx(FormattedHTMLMessage, {
        message: "ecosystem-marketplace-solutions-ui.homepage.questionnaire.industry.title"
      })
    }), /*#__PURE__*/_jsx(Select, {
      anchorType: "combined",
      options: options,
      onChange: ({
        target: {
          value
        }
      }) => handleFilterChange(value, false),
      multi: true,
      value: filters.industry
    }), guessed && /*#__PURE__*/_jsx(Small, {
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "ecosystem-marketplace-solutions-ui.homepage.questionnaire.guess"
      })
    }), renderedTopIndustries]
  });
}